import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import config from './config';

function EmailConfirm() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('Verifying Your Email...');

    useEffect(() => {
        const verifyToken = async () => {
            try {
                // *** Construct the ORIGINAL backend API URL ***
                const url = `${config.backendUrl}/emailconfirm/${token}`; // Reverted path
                console.log("Attempting to verify email with token:", token, "at URL:", url); // Log original URL

                const response = await axios.get(url);
                console.log("Verification response from backend:", response.data);

                setStatus(response.data.status || 'success');
                setMessage(response.data.message || 'Verification complete.');

                if (response.data.status === 'success' || response.data.status === 'already_verified') {
                     setTimeout(() => {
                        navigate('/login?verified=' + response.data.status);
                    }, 3000);
                }

            } catch (error) {
                console.error("Email verification failed:", error.response ? error.response.data : error.message);
                setStatus('failed');
                setMessage(error.response?.data?.message || 'Verification failed. The API endpoint might not be reachable or returned an error.');
            }
        };

        if (token) {
            verifyToken();
        } else {
            setStatus('failed');
            setMessage('Invalid verification link.');
        }
    }, [token, navigate]);

    // --- Return JSX stays the same ---
    return (
        <Box
            sx={{ /* ... styles ... */ }}
        >
            {/* ... content based on status ... */}
             {status === 'verifying' && <CircularProgress sx={{ mb: 3 }} />}
            <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
               {status === 'success' && 'Verification Successful!'}
               {status === 'already_verified' && 'Email Already Verified'}
               {status === 'failed' && 'Verification Failed'}
               {status === 'verifying' && 'Verifying Your Email...'}
            </Typography>
            <Typography variant="body1">
                {message}
            </Typography>
            {(status === 'success' || status === 'already_verified') && (
                 <Typography variant="body2" sx={{ mt: 1 }}>Redirecting to login...</Typography>
            )}
             {status === 'failed' && (
                 <Alert severity="error" sx={{ mt: 2 }}>Please check the link or contact support if the issue persists.</Alert>
             )}
        </Box>
    );
}

export default EmailConfirm;
